import React, { useCallback, useContext, useState } from "react";
import { Upload } from "lucide-react";
import { VideoContext } from "../../context/video_context";
import { Thumbnail } from "./Thumbnail";
import { cn } from "../../lib/utils";

export type DragDropFileUploadProps = {};

function DragDropFileUpload(_fn: DragDropFileUploadProps) {
  const [dragOver, setDragOver] = useState(false);
  const videoContext = useContext(VideoContext);
  const files = videoContext?.files || [];
  const setFiles = videoContext?.setFiles || (() => {});

  const handleDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    setDragOver(true);
  }, []);

  const handleDragLeave = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    setDragOver(false);
  }, []);

  const handleFilesChange = (incoming: FileList | null) => {
    if (!incoming) return;
    setFiles([]);
    const fileArray = Array.from(incoming);
    setFiles((prev: File[]) => prev.concat(fileArray));
    Array.from(incoming).forEach((f) => URL.revokeObjectURL(URL.createObjectURL(f)));
  };

  const handleDrop = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    setDragOver(false);
    handleFilesChange(event.dataTransfer.files);
  }, []);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilesChange(event.target.files);
  }, []);

  return (
    <div>
      <div
        className={cn(
          "border-2 border-dashed rounded-lg p-8 text-center cursor-pointer relative transition-colors",
          dragOver
            ? "border-primary bg-primary/5"
            : "border-border hover:border-primary/50 hover:bg-muted/50"
        )}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          accept="image/*"
          className="hidden"
          id="raised-button-file"
          multiple
          type="file"
          onChange={handleChange}
        />
        <label htmlFor="raised-button-file" className="cursor-pointer">
          <div className="flex flex-col items-center gap-3">
            <Upload className="h-10 w-10 text-primary/60" />
            <p className="text-sm text-muted-foreground">
              Drag and drop files here or{" "}
              <span className="text-primary font-medium">click to select</span>
            </p>
          </div>
        </label>
      </div>

      {files.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-4">
          {files.map((file: File, index: number) => (
            <Thumbnail key={index} image={file} />
          ))}
        </div>
      )}
    </div>
  );
}

export default DragDropFileUpload;
